import { Component, EventEmitter, Input, Output } from '@angular/core'
import { IDropdownOption } from '../../models/dropdown-option.interface'

@Component({
   selector: 'vc-dvm-medical-interests',
   templateUrl: './dvm-medical-interests.component.html',
   styleUrl: './dvm-medical-interests.component.scss',
   standalone: false,
})
export class DvmMedicalInterestsComponent {
   @Input() interests: IDropdownOption[] = []
   maxSelection = 5

   @Output() selectionChanged = new EventEmitter<IDropdownOption[]>()

   @Input() selectedInterests: IDropdownOption[] = []
   @Input() title: string = 'Medical Interests'
   @Input() idPrefix: string = 'chk-interest'
   @Input() otherSelectedInterests: IDropdownOption[] = []
   @Input() disabled = false

   toggleSelection(interest: IDropdownOption): void {
      const index = this.selectedInterests.findIndex((i) => i.id === interest.id)

      if (index > -1) {
         this.selectedInterests.splice(index, 1)
      } else if (this.selectedInterests.length < this.maxSelection) {
         this.selectedInterests.push(interest)
      }

      this.selectionChanged.emit(this.selectedInterests)
   }

   isDisabled(interest: IDropdownOption): boolean {
      const maxReached = this.selectedInterests.length >= this.maxSelection && !this.selectedInterests.find((x) => x.id === interest.id)

      return maxReached || this.disabled
   }

   isChecked(interest: IDropdownOption): boolean {
      return this.selectedInterests.map((x) => x.id).includes(interest.id)
   }
}
